import * as React from 'react';
import { FC } from 'react';
import { Form } from 'reactstrap';
import { NumberInputField } from '../../../components/Forms/fields';
import { Row } from '../../../components/Forms/table/Row';
import { Col } from '../../../components/Forms/table/Column';
import { ServiceSettings } from '../../../models/api-models';

interface ServiceConfigurationPricesTabProps {
    id: string;
    data: ServiceSettings;
    clientOrigins: string[];
    setData: React.Dispatch<React.SetStateAction<ServiceSettings>>;
}

const ServiceConfigurationPricesTab: FC<ServiceConfigurationPricesTabProps> = ({
    id,
    data,
    clientOrigins,
    setData,
}) => {
    return (
        <Form style={{ display: 'flex', marginTop: 'var(--spacer-S)', flexDirection: 'column', gap: 'var(--spacer-M)' }}>
            <Row>
                <Col md={4}>
                    <NumberInputField
                        id={`${id}-price-pvp`}
                        label="PVP"
                        prepend="€"
                        value={data.defaultPrice}
                        onChange={price =>
                            setData(d => ({
                                ...d,
                                defaultPrice: price ?? 0,
                            }))
                        }
                    />
                </Col>
            </Row>
            {clientOrigins.map(origin => (
                <Row key={origin}>
                    <Col md={4}>
                        <NumberInputField
                            id={`${id}-price-${origin}`}
                            label={origin}
                            prepend="€"
                            value={data.defaultPriceByOrigin[origin]}
                            onChange={price =>
                                setData(d => ({
                                    ...d,
                                    defaultPriceByOrigin: {
                                        ...d.defaultPriceByOrigin,
                                        [origin]: price as any, // Need this cast because CS to TS conversion is not setting "number | undefined" as expected
                                    },
                                }))
                            }
                        />
                    </Col>
                </Row>
            ))}
        </Form>
    );
};

export default ServiceConfigurationPricesTab;
